exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"documentuploadmodal.scss","sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?root=/opt/buildhome/repo/src&sourceMap!./node_modules/postcss-loader!./node_modules/sass-loader?outputStyle=expanded&sourceMap=true&sourceMapContents=true!./src/app/components/documentUploadModal/documentuploadmodal.scss
// module id = 1014
// module chunks = 0